<template>
    <div>
        <template v-if="isStatic">
            <div class="form-control form-control--static" :class="className">
                {{ item.company_name }}
            </div>
        </template>
        <template v-else>
            <select :id="id" :name="name" class="form-control form-control--select" :class="className" :tabindex="tabindex" @change="onChangeItem">
                <template v-if="hasPlaceholder">
                    <option value="0" :selected="isSelectedItem(0)">{{ placeholder }}</option>
                </template>
                <template v-if="$store.getters.userIsAdmin" v-for="item in items">
                    <optgroup :label="item.label">
                        <template v-for="option in item.items">
                            <option :value="option.id" :selected="isSelectedItem(option.id)">{{ option.company_name }}</option>
                        </template>
                    </optgroup>
                </template>
                <template v-else v-for="item in items">
                    <template v-for="option in item.items">
                        <option :value="option.id" :selected="isSelectedItem(option.id)">{{ option.company_name }}</option>
                    </template>
                </template>
            </select>
        </template>
    </div>
</template>

<script>
    export default {
        props : {
            id : {
                type : String,
                default : 'form-field-location'
            },
            name : {
                type : String,
                default : 'location_id'
            },
            value : {
                type : [String, Number],
                default : ''
            },
            placeholder : {
                type : String,
                default : ''
            },
            className : {
                type : String,
                default : ''
            },
            tabindex : {
                type : [String, Number],
                default : ''
            },
            isStatic : {
                type : Boolean,
                default : false
            },
            customerId : {
                type : [String, Number],
                default : ''
            }
        },
        data() {
            return {
                item    : {
                    company_name : ''
                },
                items   : []
            };
        },
        computed : {
            hasPlaceholder: function () {
                return this.placeholder !== '';
            }
        },
        watch : {
            value : function (newVal) {
                this.onSelectItem(newVal);
            }
        },
        created : function () {
            this.onUpdateItems();
        },
        methods : {
            onUpdateItems : function () {
                let promise = this.$api.clearParams()
                    .addParam('customer', this.customerId)
                    .get('locations');

                promise.then((response => {
                    var items = {};

                    response.data.data.forEach((function (item) {
                        if (!items[item.customers.id]) {
                            items[item.customers.id] = {
                                label : item.customers.company_name,
                                items : []
                            };
                        }

                        items[item.customers.id].items.push(item);
                    }).bind(this));

                    this.items = items;
                }).bind(this)).catch((error => {
                    this.items = [];
                }).bind(this)).finally((() => {
                    if (this.value) {
                       this.onSelectItem(this.value);
                    }
                }).bind(this));
            },
            onSelectItem : function (id) {
                var item = this.getItemById(id);

                if (item) {
                    this.item = item;
                } else {
                    this.item = {
                        company_name : ''
                    };
                }

                this.$emit('input', id);
                this.$emit('change', item);
            },
            onChangeItem : function (event) {
                this.onSelectItem(parseInt(event.currentTarget.value));
            },
            getItemById : function (id) {
                var output = null;

                for (var key in this.items) {
                    this.items[key].items.forEach((function (item) {
                        if (item.id === id) {
                            output = item;
                        }
                    }).bind(this));
                }

                return output;
            },
            isSelectedItem : function (id) {
                return parseInt(this.value) === parseInt(id);
            }
        }
    }
</script>